"use client";

import * as React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

import { hasFeature } from "./hasFeature";
import { useUser } from "../../api/hooks";
import { CloudFeatures } from "../../types/features";

interface FeatureGuardProps {
    children: React.JSX.Element;
    feature: CloudFeatures;
}

export function FeatureGuard(props: FeatureGuardProps): React.JSX.Element {
    const { isAuthenticated, isLoading: authLoading } = useAuth0();
    const navigate = useNavigate();

    const canLoadUser = !authLoading && isAuthenticated;

    //console.log("canloaduser: " + canLoadUser)

    const { data: userData, isLoading: userLoading } = useUser({
        enabled: canLoadUser,
    });

    React.useEffect(() => {
        if (authLoading) {
            return;
        }

        if (!isAuthenticated) {
            return;
        }

        if (userLoading || !userData) {
            return;
        }

        const valid = hasFeature(userData, props.feature);

        if (!valid) {
            navigate("/errors/not-authorized", { replace: true });
        }
    }, [
        authLoading,
        isAuthenticated,
        userLoading,
        userData,
        props.feature,
        navigate,
    ]);

    if (authLoading || !isAuthenticated || userLoading || !userData) {
        return <></>;
    }

    const valid = hasFeature(userData, props.feature);

    if (!props.feature || !valid) {
        return <></>;
    }

    return <>{props.children}</>;
}
